import { render, staticRenderFns } from "./GRZHQXKTHBGSQB.vue?vue&type=template&id=20d64b34&scoped=true"
import script from "./GRZHQXKTHBGSQB.vue?vue&type=script&lang=js"
export * from "./GRZHQXKTHBGSQB.vue?vue&type=script&lang=js"
import style0 from "./GRZHQXKTHBGSQB.vue?vue&type=style&index=0&id=20d64b34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d64b34",
  null
  
)

export default component.exports